<template>
  <div class="flex flex-col gap-1 items-stretch w-full">
    <!-- Quantity (on top) -->
    <div class="w-full h-[36px] overflow-hidden">
      <div class="flex flex-row justify-between items-center h-full border-2 border-black bg-white">
        <button
          @click="decrementQuantity"
          class="flex items-center justify-center w-[18px] h-full hover:bg-black/5"
          :aria-label="$t('cart.decrease')"
        >
          <svg class="w-4 h-4" viewBox="0 0 16 16" fill="none">
            <path d="M3.33337 8H12.6667" stroke="#1E1E1E" stroke-width="1.6"/>
          </svg>
        </button>

        <input
          type="number"
          v-model.number="quantity"
          min="1"
          class="font-archivo font-bold text-[14px] text-[#010101] text-center w-[50px] h-full border-0 focus:outline-none appearance-none"
          :aria-label="$t('cart.quantity')"
          style="-moz-appearance: textfield;"
          @focus="$event.target.select()"
        />

        <button
          @click="incrementQuantity"
          class="flex items-center justify-center w-[18px] h-full hover:bg-black/5"
          :aria-label="$t('cart.increase')"
        >
          <svg class="w-4 h-4" viewBox="0 0 16 16" fill="none">
            <path d="M8 3.33337V12.6667M3.33337 8H12.6667" stroke="#1E1E1E" stroke-width="1.6"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- ADD button (below) -->
    <button class="w-full h-[36px] bg-black flex items-center justify-center" @click="addToCart">
      <span class="font-archivo-narrow font-bold text-[16px] leading-[20px] text-[#FFDD00]">
        {{ $t('cart.addToCart') }}
      </span>
    </button>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

// eslint-disable-next-line no-undef
const emit = defineEmits(['add-to-cart'])

const quantity = ref(1)

const incrementQuantity = () => { quantity.value++ }
const decrementQuantity = () => { if (quantity.value > 1) quantity.value-- }

watch(quantity, (newValue) => {
  let numValue = parseInt(newValue)
  if (isNaN(numValue) || numValue < 1) {
    quantity.value = 1
  } else {
    // Limit it to 5 characters: 99999
    quantity.value = Math.min(numValue, 99999)
  }
})

const addToCart = () => {
  emit('add-to-cart', quantity.value)
}
</script>

<style scoped>
.font-archivo-narrow { font-family: 'Archivo Narrow', sans-serif; }
.font-archivo { font-family: 'Archivo', sans-serif; }
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
input[type="number"] { -moz-appearance: textfield; appearance: textfield; }
</style>

